<script setup lang="ts">
import { getMetaTags } from '~/utils/meta'
import type { BreadcrumbItem } from '@nuxt/ui'
import { heroImages } from '#shared/models/images'

definePageMeta({
  layout: false
})

defineRouteRules({
  prerender: true
})

const { t, tm, baseKey } = useI18n('pages.static.onze-impact')

const heroImage = heroImages['vincent-en-irma']

useSeoMeta(
  getMetaTags(
    {
      title: '.meta.title',
      description: '.meta.description'
    },
    heroImage.src,
    baseKey
  )
)

useSchemaOrg(
  getSchemaOrg(
    {
      title: '.title',
      breadcrumbs: [{ name: '.title' }]
    },
    baseKey
  )
)

const breadcrumbItems: BreadcrumbItem[] = [{ label: '.title', to: 'onze-impact' }]

const changeItems = computed<string[]>(() => tm('.section-three.items'))
</script>

<template>
  <NuxtLayout
    name="default"
    title=".title"
    description=".description"
    :image="heroImage"
    :ui="{
      image: 'lg:object-[center_-3rem]'
    }"
  >
    <VBreadcrumb :items="breadcrumbItems" />

    <VSection>
      <p>
        {{ t('.section-one.description-one') }}
      </p>

      <p>
        {{ t('.section-one.description-two') }}
      </p>

      <p>{{ t('.section-one.description-three') }}</p>
    </VSection>

    <OurImpactSection />

    <ListSection
      title=".section-three.title"
      description=".section-three.description"
      :items="changeItems"
    />

    <VSection title=".section-four.title">
      <p>
        {{ t('.section-four.description-one') }}
      </p>

      <p>
        {{ t('.section-four.description-two') }}
      </p>
    </VSection>
  </NuxtLayout>
</template>

<style scoped></style>
